import moment from 'moment';
import {throttle} from '../../utils/util';

const PluginPlayHistory = window.Aliplayer
  ? window.Aliplayer.Component({
      init: function(id?:number | string) {
        this.sourceId = id;
        this.player = null;
        this.bindTimeUpdate = throttle(this.timeUpdate.bind(this), 3000);
      },
      createEl: function(el: any, player: any) {
        this.player = player;
        this.player.on('timeupdate', this.bindTimeUpdate);
      },
      timeUpdate: function() {
        let current = this.player.getCurrentTime();
        window.localStorage.setItem(`lastplay_${this.sourceId}`, current);
      }
    })
  : null;

export default PluginPlayHistory;
